import React, { useEffect, useState } from 'react';
import { Timeline } from 'antd';
import { EnvironmentOutlined, InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Container, Dados, History, ItemDados, ItemTimeLine } from './styles';
import RelatarProblema from '../RelatarProblema';
import GetStatus from '../../../../../components/GetStatus';
import api from '../../../../../service/api';
import { SKW_PREFIX } from '../../../../../utils/constants';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import Spin from 'components/Spin';
import Swal from 'sweetalert2';
import mask from 'utils/mask';

interface PropsData {
  data: Date | string;
  posicao: string;
}

export const ItensTracking: React.FC<{ record: any }> = ({ record }) => {
  const Item = Timeline.Item;
  const [data, setData] = useState<PropsData[]>([]);
  const [total, setTotal] = useState<number>(0);

  const [loading, setLoading] = useState<boolean>(false);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  useEffect(() => {
    let controller = new AbortController();
    setLoading(true);
    api
      .post(`call?serviceName=${SKW_PREFIX}getLocalizacao&token=${token}`, {
        cteNunota: record?.cteNunota,
      })
      .then((res) => {
        setData(res?.data?.locais);
        setTotal(res?.data?.total);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Erro ao buscar localização',
          text: err?.response?.data?.message,
        });
      });
    return controller.abort();
  }, [record?.cteNunota, token]);

  return (
    <Container>
      {!loading ? (
        <History total={total} maxHeight="300px" minHeight="200px">
          {total > 0 ? (
            <Timeline mode="left" style={{ padding: '5px' }}>
              {data.map((item) => {
                const localizacao = item.posicao ? item.posicao : 'Localização não informada, ';
                const date = item.data ? (
                  <ItemTimeLine>
                    <EnvironmentOutlined style={{ marginRight: '20px' }} />{' '}
                    <div>{moment(item.data).format('LLL')}</div>
                  </ItemTimeLine>
                ) : (
                  ' data não informada'
                );
                return <Item label={date}>{localizacao}</Item>;
              })}
            </Timeline>
          ) : (
            <p
              style={{
                margin: '20px',
                fontSize: '20px',
              }}
            >
              <InfoCircleOutlined /> Não há localizações informadas para este CT-e
            </p>
          )}
        </History>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Spin color="#00b1f1" />
        </div>
      )}

      <Dados>
        <ItemDados style={{ textAlign: 'center', fontSize: '18px' }}>
          <GetStatus acronym={record?.status} />
        </ItemDados>
        <ItemDados>
          <div>Origem: </div>
          <strong>
            {record.cidadeOrigem ? mask('cidadeUf', record.cidadeOrigem) : 'Não informado'}
          </strong>
        </ItemDados>
        <ItemDados>
          <div>Destino:</div>
          <strong>
            {record.cidadeDestino ? mask('cidadeUf', record.cidadeDestino) : 'Não informado'}
          </strong>
        </ItemDados>
        <ItemDados>
          <div>Data de saída:</div>
          <strong>
            {record.dtSaida ? moment(record.dtSaida).format('LLLL') : 'Não informado'}
          </strong>
        </ItemDados>
        <ItemDados>
          <div>Prazo de entrega acordado:</div>
          <strong>
            {record.dtPrazoAcordado
              ? moment(record.dtPrazoAcordado).format('LLLL')
              : 'Não informado'}
          </strong>
        </ItemDados>
        <ItemDados>
          <div>Chegada prevista para:</div>
          <strong>
            {record.dtPrevChegada ? moment(record.dtPrevChegada).format('LLLL') : 'Não informado'}
          </strong>
        </ItemDados>

        <ItemDados style={{ marginTop: '30px' }}>
          <RelatarProblema record={record} />
        </ItemDados>
      </Dados>
    </Container>
  );
};
